@if (isAuthReady$ | async) {
  @if (isAuthenticated$ | async) {
    <mat-sidenav-container autosize class="sidenav-container">
      <mat-sidenav #sidenav 
        (mouseenter)="onSidenavMouseEnter()" 
        (mouseleave)="onSidenavMouseLeave()"
        [mode]="isHandset() ? 'over' : 'side'" 
        [opened]="!isHandset()"
        [disableClose]="!isHandset()"
        [@sidebarAnimation]="sidebarState()"
        (@sidebarAnimation.done)="onSidebarAnimationDone()"
        class="sidenav">
        <app-nav [user]="user$ | async" 
          [iconOnly]="isIconOnly()"
          (closeSidenav)="isHandset() ? sidenav.close() : null" />
      </mat-sidenav>
      
      <mat-sidenav-content class="content">
        <app-header [user]="user$ | async" [isMobile]="isHandset()" (toggleSidenav)="sidenav.toggle()" />
        
        <main class="main-content">
          <router-outlet />
        </main>

        @if (isAuthenticated$ | async) {
          <button mat-fab color="primary" class="add-trip-fab" (click)="addTrip()" aria-label="Add Trip">
            <mat-icon>add</mat-icon>
          </button>
        }
      </mat-sidenav-content>
    </mat-sidenav-container>
  } @else {
    <router-outlet />
  }
} @else {
  <div class="initial-loading">
    <mat-spinner diameter="64" class="bid-spinner"></mat-spinner>
    <p>Initializing TCH Mileage Tracker...</p>
  </div>
}

<div class="app-version" (click)="openChangelog()" role="button" tabindex="0" (keydown.enter)="openChangelog()" (keydown.space)="openChangelog()" title="View Changelog">v{{ appVersion }}</div>

@if (loadingService.isLoading()) {
  <div class="loading-overlay">
    <mat-spinner diameter="64" class="bid-spinner"></mat-spinner>
    <p>{{ loadingService.loadingMessage() }}</p>
  </div>
}
